import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import LBCo6 from 'dc/LBCo6';

import { useText, useFormatNumber, useImage } from 'common/hooks';
import { getIndicatorConfig } from 'utils/common';
import { Leaderboard } from 'challenge/module/modules/visualisations/types';

type Props = {
  readonly entry: Leaderboard;
};

const deps = {
  indicator: state.challenge.campaign.indicator,
};

function LeaderboardEntry({
  entry,
  indicator,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const formatNumber = useFormatNumber();
  const [url, isLoading] = useImage(entry.avatar);

  const { icon, color, precision } = getIndicatorConfig(indicator);

  return (
    <LBCo6
      isLoading={isLoading}
      avatarImage={url}
      position={entry.position}
      noValue={entry.value === 0}
      isEmphasised={entry.isEmphasised}
      activities={formatNumber(entry.activityCount, 0)}
      value={formatNumber(entry.value, precision)}
      name={entry.name || t('challenge.ChaPaD22B.LB01.deleted_user')}
      icon={icon}
      color={color}
    />
  );
}

export default connect<Props, typeof deps>(deps, LeaderboardEntry);
